<template>
    <div>
        <base-dialog @close="close" :open="show" newClass="w3-modal-content w3-card-4 ">
            <template #default>

                <div style="max-width:600px">
                    <div class="w3-margin-top"></div>
                    <div class="container-fluid w3-margin-top"> 
                        <div class="row w3-margin-top">
                            <div class="col-md-12">
                                <h3>Catalog Part: {{ product.QITEMC }}</h3>
                            </div>
                            <div class="col-sm-9 w3-margin-top">
                                <select size="10" style="width: 100%" v-model="selected_opt" v-if="related_opts.length > 0">
                                    <option v-for="(option, index) in related_opts" :key="index" :value="option.QCTYP">
                                        {{option.QCTYPD}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

            </template>

            <template #actions>
                <div class="w3-container w3-border-top w3-padding-16 w3-light-grey buttons">
                    <button @click="close" type="button" class="w3-button w3-red w3-left"><strong>Cancel</strong></button>
                    <button @click="select" class="w3-button w3-green w3-right"><strong>OK</strong></button>
                </div>
            </template>
        </base-dialog>
    </div>
</template>

<script>
    import axiosvl from "../../../axios/axios-vl.js";
    import { mapGetters } from 'vuex';
    // import * as GCONST from '../../../constants.js';

    export default {
        data() {
            return {
                // prod
                product : {},
                related_opts: [],
                show: false,
            };
        },

        computed: {
            ...mapGetters([
                'storeCatalog', 
                'customerIndicator',
                'storefrontAttributes'
            ]),
        },

        props: {
            // product : {
            //     type : Object,
            //     required: true
            // },
        },

        methods: {
            close() {
                
                this.show = false;
            },
            
            getRelatedTypes(product) {
                this.product = product;
                this.show = true;
                this.related_opts= [];
                this.isloading = true;
                const related_types_uri = this.$store.getters['api/related_types_uri'];
                // const catpn = (this.storeCatalog.toUpperCase() == 'WHI') ? '003' : '002';
                const catpn = this.$store.getters['storeConfigID'];
                const params = {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": { "value": this.$store.getters.customer },
                            "CATPN": {"value": catpn },
                            "QYEAR": {"value": this.$store.getters['vehicle/selectedyear'] },
                            "QMAKE": {"value": this.$store.getters['vehicle/selectedmake'].selectedmake },
                            "QMODEL": {"value": this.$store.getters['vehicle/selectedmodel'].selectedmodel },
                            "QCARCD": {"value": this.$store.getters['vehicle/selectedengine'].selectedengine },
                            "QTYPEC": {"value": this.product.QTYPEC },
                            "USG": {"value": this.product.QIGSEQ },
                            "QMFRCD": {"value": this.product.manufacturer },
                            "QITEMC": {"value": this.product.QITEMC },
                        }
                    }
                }

                // console.log(this.$store.getters['vehicle/selectedcategories']);
                // console.log(related_types_uri);
                
                axiosvl.post(related_types_uri, params)
                .then((response) => {
                    const CTYPSD = response.data.webroutine.lists.CTYPSD;
                    CTYPSD.entries.forEach(opt => {
                        this.related_opts.push(opt);
                    });

                    this.isloading = false;
                })
                .catch((error) => {
                    console.log("error - " + error);
                    this.isloading = false;
                });
            },

            select() {
                this.show = false;
                this.$emit('selected_type', this.selected_opt);
            }
        },

        

        created() {
            // console.log('RelatedPartTypes - created');
            // this.getRelatedTypes();
        }
    }
</script>

<style scoped>
    .buttons {
        width: 100%;
    }
</style>